<template>
  <div
    class="w-full bg-[#fde094] px-4 py-[6px]"
    v-if="currentUser && currentUser.should_complete_quiz && !isCosedQuizAlert"
  >
    <div class="no-print relative w-full px-4 md:px-6 xl:px-[94px]">
      <div
        class="max-w-8xl mx-auto flex w-full flex-row flex-wrap items-center space-y-2 md:space-y-0"
      >
        <div
          class="flex w-full items-center space-x-2 text-body-7-d sm:w-2/3 lg:w-3/4"
        >
          <img
            class="h-[22px] w-[24px] flex-shrink-0"
            src="@/assets/images/base/icons/info-black.svg"
            loading="lazy"
            alt="info-black-icon"
          />
          <p>
            {{ $t("alerts.complete_quiz") }}
          </p>
        </div>

        <div class="w-full text-center sm:w-1/3 lg:w-1/4">
          <a :href="getLandingPageUrl('quiz')">
            <CoreButtonBase class="px-[44px]" theme="secondary">
              {{ $t("action.complete_the_form") }}
            </CoreButtonBase>
          </a>
        </div>
      </div>

      <button class="absolute right-0 top-1/2 -translate-y-1/2 transform">
        <img
          src="@/assets/images/base/icons/close.svg"
          loading="lazy"
          class="shrink-0"
          @click="setClosedQuizAlert(true)"
        />
      </button>
    </div>
  </div>
</template>

<script>
import CoreButtonBase from "@/components/Core/ButtonBase.vue";
import { mapGetters, mapMutations } from "vuex";
import landingPageMixin from "@/mixins/landingPageMixin";

export default {
  name: "GeneralQuizBar",
  mixins: [landingPageMixin],
  components: { CoreButtonBase },
  computed: {
    ...mapGetters({
      currentUser: "user/getCurrentUser",
      isCosedQuizAlert: "app/isCosedQuizAlert",
    }),
  },
  methods: {
    ...mapMutations({
      setClosedQuizAlert: "app/setClosedQuizAlert",
    }),
  },
};
</script>
